import React from 'react';
import { isAnyCountry } from '@scale/shared/workerSlack/helpers';
import Tooltip from 'design-system/Tooltip';

const getFlagEmoji = (countryCode: string) => {
  const codePoints = countryCode
    .toUpperCase()
    .split('')
    .map((char: $FIXME) => 127397 + char.charCodeAt());
  return String.fromCodePoint(...codePoints);
};

const regionNames = new Intl.DisplayNames(['en'], { type: 'region' });

const SlackChannelCountries = (props: $FIXME) => {
  return (
    <>
      <div className="item-option-container">
        <label>Countries: </label>
        <div className="countries-container">
          {!isAnyCountry(props.channel.countries) &&
            props.channel.countries.map((country: string) => (
              <div key={country} className={`country-box-container  country-box-${country}`}>
                <Tooltip
                  title={country === '' ? 'Entire Earth' : regionNames.of(country)}
                  placement="top"
                  arrow
                >
                  <div className="country-box">
                    {country === '' ? `🌎 Global` : `${getFlagEmoji(country)} ${country}`}
                  </div>
                </Tooltip>
              </div>
            ))}
          {!!isAnyCountry(props.channel.countries) && (
            <div className={`country-box-container  country-box-level-${null}`}>
              <div className="country-box">{`🌎 Global`}</div>
            </div>
          )}
        </div>
      </div>
      <style>{`
        label {
          font-weight: 500;
          padding-right: 4px;
        }
        .countries-container {
          display: flex;
          flex-wrap: wrap;
          max-width: 300px;
          margin-left: 8px;
        }
        .country-box-container {
          width: 70px;
          border-radius: 32px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 4px;
          border: 1px solid var(--color-RemoGray50);
        }
        .item-option-container {
          display: flex;
          flex-direction: row;
          align-items: center;
        }

        .country-box {
          padding: 4px 12px;
          white-space: nowrap;
        }
      `}</style>
    </>
  );
};

export default SlackChannelCountries;
